export default __webpack_public_path__ + "static/homework-5a80a362481622206d6a16c1830243c2.png";